import React, { useEffect, useRef, useState, useContext } from "react";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LANGUAGE_OPTIONS } from "../constants/options";
import { PAGE } from "../constants/page";
import "../styles/components/ProfileMenu.scss";
import LanguageContext from "../contexts/LanguageContext";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@els/els-react--dropdown";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";
import { useAppSelector } from "../redux/hooks";
import { UserConfigState } from "../redux/reducers/UserConfigSlice";

type Props = {
  firstName: string;
  lastName: string;
  onClickOutside: any;
  onLogout: any;
  userLanguageSelected: any;
  handleLanguageChange: (e: any) => void;
  userType: any;
  onHelp: any;
};

const ProfileMenu = (props: Props) => {
  const wrapperRef = useRef(null);
  const { firstName, lastName, onClickOutside, onLogout, onHelp } = props;
  const navigate = useNavigate();
  const { language, setLanguage } = useContext(LanguageContext);
  const { i18n } = useTranslation();
  const userConfigDetails: any = useAppSelector(UserConfigState);

  const handleViewProfile = () => {
    let routeLink;
    if (
      props.userType === "Global Admin" ||
      props.userType === "State Admin" ||
      props.userType === "Global Admin Support"
    ) {
      routeLink = PAGE.USER_PROFILE.replace(":role", "admin");
    }else if (props.userType === "Anm") {
      routeLink = PAGE.USER_PROFILE.replace(":role", "anm");
    } else {
      routeLink = PAGE.USER_PROFILE.replace(":role", "asha");
    }

    navigate(routeLink);
    onClickOutside();
  };

  const handleHelp = () => {
    onClickOutside();
    onHelp();
  };

  const handleLogout = () => {
    onClickOutside();
    onLogout();
  };

  useEffect(() => {
    if (isMobile) {
      const body = document.getElementsByTagName("body")[0];
      body.style.overflow = "hidden";
      return () => {
        body.style.overflow = "visible";
      };
    }
  }, []);

  useEffect(() => {
    const specifiedElement = document.getElementById(
      "profile_menu"
    ) as HTMLElement;
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !specifiedElement.contains(event.target)) {
        onClickOutside();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div>
      <BrowserView>
        <div className="profile-menu" id="profile_menu" ref={wrapperRef}>
          <span className="triangle-up"></span>
          <ul className="inner-menu">
            <li className="name">{`${firstName} ${lastName}`}</li>
            <li onClick={handleViewProfile}>
              <img className="pe-2" src="/icons/profile.svg" />{" "}
              <Trans i18nKey={"view_profile"}></Trans>
            </li>
            <li onClick={handleHelp}>
              <img className="pe-2" src="/icons/help.svg" />{" "}
              <Trans i18nKey={"help"}></Trans>
            </li>
            <li onClick={handleLogout}>
              <img className="pe-2" src="/icons/logout.svg" />{" "}
              <Trans i18nKey={"logout"}></Trans>
            </li>
          </ul>
        </div>
      </BrowserView>
      <MobileView>
        <div className="profile-menu-mobile">
          <div className="name">
            <div
              className="name-inner"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <button className={"userInitials"}>
                  {`${firstName?.charAt(0)}${lastName?.charAt(0)}`}
                </button>
                <span className="ps-2">{`${firstName} ${lastName}`}</span>{" "}
              </div>
              <div
                // className={"langaugeSelection"}
                style={{ alignSelf: "center" }}
              >
                {" "}
                <Dropdown
                  selected={{
                    label: userConfigDetails?.countryLanguageOptions.filter((langLabelValueObj: any) => {
                      return (
                        langLabelValueObj.id === props.userLanguageSelected
                      );
                    })[0]?.label,
                  }}
                  showSelectedAsLabel={true}
                  id="language-select"
                  options={userConfigDetails?.countryLanguageOptions.map((options: {}) => {
                    return {
                      ...options,
                      onClick: props.handleLanguageChange,
                      // render: () => (
                      //   <a id={options.id} onClick={props.handleLanguageChange}>
                      //     {options.label}
                      //   </a>
                      // ),
                    };
                  })}
                  flyoutProps={{
                    placement: "bottom-end",
                    pointer: false,
                    pointerType: "primary",
                  }}
                />
              </div>
            </div>
          </div>
          <ul className="inner-menu" id="ul">
            <li onClick={handleViewProfile}>
              <img className="pe-2" src="/icons/profile.svg" />{" "}
              <Trans i18nKey={"view_profile"}></Trans>
            </li>
            <li onClick={handleHelp}>
              <img className="pe-2" src="/icons/help.svg" />{" "}
              <Trans i18nKey={"help"}></Trans>
            </li>
            <li onClick={handleLogout}>
              <img className="pe-2" src="/icons/logout.svg" />{" "}
              <Trans i18nKey={"logout"}></Trans>
            </li>
          </ul>
        </div>
      </MobileView>
    </div>
  );
};

export default ErrorBoundaryHandler(ProfileMenu);
